

<div id="">
   <header id="banner" role="banner">
      <nav class="site-breadcrumbs" id="breadcrumbs">
         <!--<h1> <span>Elementi Navigazione</span> </h1>--> 
         <ul class="breadcrumbs breadcrumbs-horizontal lfr-component">
            <li class="first"><span><a routerLink="">SIRA</a></span></li>
            <li><span><a href="/sirang/miinteressa">AREE TEMATICHE</a></span></li>
            <li class="last"><span><a href="/sirang/conservazionenatura">CONSERVAZIONE NATURA</a></span></li>
         </ul>
      </nav>
   </header>
   <div id="content">
      <div class="portlet-boundary portlet-boundary_103_ portlet-static portlet-static-end " id="p_p_id_103_">
         <span id="p_103"></span> 
         <div class="portlet-body"> </div>
      </div>
      <div class="columns-2" id="main-content" role="main">
         <div class="portlet-layout">
            <div class="aui-w70 portlet-column portlet-column-first" id="column-1">
               <div class="portlet-dropzone portlet-column-content portlet-column-content-first" id="layout-column_column-1">
                  <div class="portlet-boundary portlet-boundary_56_ portlet-journal-content  portlet-draggable" id="p_p_id_56_INSTANCE_zROtZn5qjxGT_">
                     <span id="p_56_INSTANCE_zROtZn5qjxGT"></span> 
                     <div class="portlet-body">
                        <section class="portlet" id="portlet_56_INSTANCE_zROtZn5qjxGT">
                           <table style="width: 100%;">
                              <tbody>
                                 <tr>
                                    
                                    <td>
                                       <header class="portlet-topper gradient">
                                          <h1 class="portlet-title"> <span class="portlet-title-text portlet-title-editable" style="margin-left: 0px;">Conservazione della natura e della biodiversità</span> </h1>
                                       </header>
                                    </td>
                                 </tr>
                              </tbody>
                           </table>
                           <div class="portlet-content">
                              <div class=" portlet-content-container" style="">
                                 <div class="portlet-body">
                                    <div class="journal-content-article">

                                       <p > I moduli applicativi per l'area tematica <strong>Conservazione delle natura e della biodiversità</strong> hanno lo scopo di supportare in particolar modo l'attività e le esigenze informative dei Servizi regionali "Tutela della natura" e "Tutela del suolo e politiche forestali", dei servizi regionali che si occupano di problematiche fitosanitarie, delle Province, di ARPAS e dell'Ente Foreste della Sardegna.</p>
                                       <p > Nell'ambito di quest'area tematica si rende necessaria la progettazione e la realizzazione di molteplici sezioni, che di seguito vengono riassunti:</p>
                                       <ul>
                                          <li> Gestione aree protette e tutelate;</li>
                                          <li> Gestione della fauna e dell'attività venatoria (compresa gestione danni da fauna selvatici);</li>
                                          <li> Gestione forestale Ente Foreste (compreso PFAR);</li>
                                          <li> Monitoraggi relativi alle matrici ambientali monitorate nell'ambito di questa area tematica.</li>
                                       </ul>
                                    </div>
                                    <div class="entry-links"> </div>
                                 </div>
                              </div>
                           </div>
                        </section>
                     </div>
                  </div>
               </div>
            </div>


            <div class="aui-w30 portlet-column portlet-column-last" id="column-2">
               <div class="portlet-dropzone portlet-column-content portlet-column-content-last" id="layout-column_column-2">
                  <div class="portlet-boundary portlet-boundary_56_ portlet-journal-content  portlet-draggable" id="p_p_id_56_INSTANCE_ieAw63KB7TJL_">
                     <span id="p_56_INSTANCE_ieAw63KB7TJL"></span> 
                     <div class="portlet-body">
                        <section class="portlet" id="portlet_56_INSTANCE_ieAw63KB7TJL">
                           <table style="width: 100%;">
                              <tbody>
                                 <tr>
                                    
                                    <td>
                                       <header class="portlet-topper gradient">
                                          <h1 class="portlet-title"> <span class="portlet-title-text" style="margin-left: 0px;">Dati ambientali</span> </h1>
                                       </header>
                                    </td>
                                 </tr>
                              </tbody>
                           </table>
                           <div class="portlet-content">
                              <div class=" portlet-content-container" style="">
                                 <div class="portlet-body">
                                    <div class="journal-content-article">
                                       <ul>
                                          <li> <a target="_blank" href="https://portal.sardegnasira.it/web/sardegnaambiente/dati-ambientali-natura-e-biodiversita">Vai alla pagina</a></li>
<!--
                                          <li> <u>RAS_Servizio tutela dell'atmosfera e del territorio </u></li>
                                          <li> <u>ARPA Sardegna</u></li>
                                          <li> <u>Pubbliche amministrazioni locali regional</u>i</li>
-->                                          
                                       </ul>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </section>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <form action="#" id="hrefFm" method="post" name="hrefFm"> <span></span> </form>
   </div>
</div>